import { graphql } from 'react-relay/legacy';

const contemporaryLandingRootQuery = graphql`
    query contemporaryLandingRootQuery($contemporaryLandingPreviewId: String!) {
        viewer {
            ...ContemporaryLandingRespLayout_viewer
            contemporaryLanding(rootId: $contemporaryLandingPreviewId) {
                ...getContemporaryLandingMetaContent_contemporaryLanding @relay(mask: false)
            }
        }
    }
`;

const contemporaryLandingVariables = {
    contemporaryLandingPreviewId: '',
};

export { contemporaryLandingRootQuery, contemporaryLandingVariables };
